var {
  useProviderProps
} = require("@react-spectrum/provider");

var _react = $parcel$interopDefault(require("react"));

var {
  filterDOMProps
} = require("@react-aria/utils");

var {
  classNames,
  useDOMRef,
  useSlotProps,
  useStyleProps
} = require("@react-spectrum/utils");

var _babelRuntimeHelpersObjectWithoutPropertiesLoose = $parcel$interopDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _babelRuntimeHelpersExtends = $parcel$interopDefault(require("@babel/runtime/helpers/extends"));

require("./main.css");

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/components/image/vars.css
var $dc944e22165228885fea4aea15d01cb2$exports = {};
$dc944e22165228885fea4aea15d01cb2$exports = {
  "spectrum-Image-img": "_spectrum-Image-img_1ecbc"
};
var $dc944e22165228885fea4aea15d01cb2$$interop$default = $parcel$interopDefault($dc944e22165228885fea4aea15d01cb2$exports);

// incomplete component for show right now
function $cdebc9a3e4a86d825a45e81735fc19$var$Image(props, ref) {
  /* Slots should be able to pass an alt for default behavior, but in Images, the child may know better. */
  let userProvidedAlt = props.alt;
  props = useSlotProps(props, 'image');
  props = useProviderProps(props);

  let {
    objectFit,
    src,
    alt
  } = props,
      otherProps = _babelRuntimeHelpersObjectWithoutPropertiesLoose(props, ["objectFit", "src", "alt"]);

  let {
    styleProps
  } = useStyleProps(otherProps);
  let domRef = useDOMRef(ref);

  if (alt == null) {
    console.warn('The `alt` prop was not provided to an image. ' + 'Add `alt` text for screen readers, or set `alt=""` prop to indicate that the image ' + 'is decorative or redundant with displayed text and should not be announced by screen readers.');
  }

  return /*#__PURE__*/_react.createElement("div", _babelRuntimeHelpersExtends({}, filterDOMProps(props), styleProps, {
    className: classNames($dc944e22165228885fea4aea15d01cb2$$interop$default, styleProps.className),
    style: _babelRuntimeHelpersExtends({}, styleProps.style, {
      overflow: 'hidden'
    }),
    ref: domRef
  }), /*#__PURE__*/_react.createElement("img", {
    src: src,
    alt: userProvidedAlt || alt,
    style: {
      objectFit
    },
    className: classNames($dc944e22165228885fea4aea15d01cb2$$interop$default, 'spectrum-Image-img')
  }));
}
/**
 * Image is used to insert and display an image within a component.
 */


const Image = /*#__PURE__*/_react.forwardRef($cdebc9a3e4a86d825a45e81735fc19$var$Image);

exports.Image = Image;
